import { Controller } from "@hotwired/stimulus"

// Polls a status endpoint until the flow can move forward. Auth pages can't
// rely on Turbo Stream broadcasts to arrive (multi-region: the publisher may
// not share this server's Action Cable Redis), so polling is the reliable
// path and cable is only a latency accelerator.
//
// Expected JSON response: { done, location, progress }
//   done with location   -> navigate there
//   done without location -> reload the page
//   progress              -> rendered into the progress target when present
export default class extends Controller {
  static targets = ["progress"]
  static values = {
    url: String,
    interval: { type: Number, default: 2000 }
  }

  connect() {
    this.stopped = false
    this.schedule()
  }

  disconnect() {
    this.stopped = true
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }

  schedule() {
    this.timer = setTimeout(() => this.poll(), this.intervalValue)
  }

  async poll() {
    if (this.stopped) return

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" }
      })

      if (response.ok) {
        const status = await response.json()

        if (status.done) {
          this.stopped = true
          // Let the destination page know this navigation came from the
          // poller, so update-checker doesn't mistake it for a user
          // returning after a fix and auto-click another recheck.
          sessionStorage.setItem("status_poll:navigated_at", Date.now())
          if (status.location) {
            window.location.assign(status.location)
          } else {
            window.location.reload()
          }
          return
        }

        if (status.progress && this.hasProgressTarget) {
          this.progressTarget.textContent = status.progress
        }
      }
    } catch {
      // Transient network failure: keep polling.
    }

    this.schedule()
  }
}
